export let AppIssue = {
    path: 'appissue',
    name: 'appissue',
    meta: {
        roleCode: '012',
    },
    component: () =>
        import(/* webpackChunkName: "app-issue" */ '@/views/back-stage/appissue/app-issue.vue'),
    children: [
        {
            path: 'setting',
            name: 'setting',
            component: () =>
                import(
                    /*webpackChunkName:"setting-page"*/ '@/views/back-stage/appissue/setting-page.vue'
                ),
        },
        {
            path: 'pushset',
            name: 'pushset',
            component: () =>
                import(
                    /*webpackChunkName:"pushset-page"*/ '@/views/back-stage/appissue/pushset-page.vue'
                ),
        },
        {
            path: 'loginmanage',
            name: 'loginmanage',
            component: () =>
                import(
                    /*webpackChunkName:"login-manage"*/ '@/views/back-stage/appissue/login-manage.vue'
                ),
        },
        {
            path: 'colophon',
            name: 'colophon',
            component: () =>
                import(
                    /*webpackChunkName:"app-colophon"*/ '@/views/back-stage/appissue/app-colophon.vue'
                ),
        },
        {
            path: '*',
            redirect: 'setting',
        },
    ],
};
